// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","black":"#000000","light-grey":"#d4d4d4","grey":"#707070","dark-purple":"#4a2e5e","desktop":"1366px","filterable":"z6QzTcB0nQahDNUcHXMlJ","searchInput":"_3f3Yp3Jq2C1aMVD5ITyDLe","search":"vjSuWuIKUZUnL0CIETHNa","inputLabel":"bzaOT5Jds2kW3yTpwxtSn","filterList":"_1nRu_ymmiQnNxrexLlTn1b","filters":"_3AAyIOQ_LK993aEY9okd7E","active":"_2DpeqlmN1cHGf1D84PDBW6","link":"_1d6Qi_N5jee605fDhiqXzn","flexDirection":"YwkGNiG7Jl449-AwWXvmv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Filterable/Filterable.css
// module id = 664
// module chunks = 0